import * as Types from '../../types';

import { gql } from '@apollo/client';
import { EntityDisplayFragmentDoc } from '../../components/EntityDisplay/EntityDisplay.generated';
import { AddressRiskIndicatorFragmentDoc } from '../../components/RiskIndicator/RiskIndicator.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetListQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  itemFilters?: Types.InputMaybe<Array<Types.FilterInput> | Types.FilterInput>;
  itemSort?: Types.InputMaybe<Types.SortInput>;
}>;

export type GetListQuery = {
  __typename?: 'Query';
  list?: {
    __typename?: 'List';
    id: any;
    name: string;
    description?: string | null;
    status: Types.ListStatus;
    isSystem: boolean;
    itemType: Types.ListItemType;
    createdAt: any;
    updatedAt: any;
    items: {
      __typename?: 'ListItemConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'ListItemEdge';
        node: {
          __typename?: 'ListItem';
          id: any;
          createdAt: any;
          value: {
            __typename?: 'Address';
            address: string;
            label?: string | null;
            entity?: {
              __typename?: 'Entity';
              id: any;
              name: string;
              risks: {
                __typename?: 'EntityRiskConnection';
                totalCount: number;
                pageInfo: {
                  __typename?: 'PageInfo';
                  hasNextPage: boolean;
                  hasPreviousPage: boolean;
                  startCursor?: string | null;
                  endCursor?: string | null;
                };
                edges: Array<{
                  __typename?: 'EntityRiskEdge';
                  node: {
                    __typename?: 'EntityRisk';
                    id: any;
                    riskType: string;
                    severity: string;
                    description?: string | null;
                  };
                }>;
              };
            } | null;
            risks: {
              __typename?: 'AddressRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'AddressRiskEdge';
                node: {
                  __typename?: 'AddressRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          };
        };
      }>;
    };
  } | null;
};

export const GetListDocument = gql`
  query GetList(
    $id: UUID!
    $itemFilters: [FilterInput!]
    $itemSort: SortInput
  ) {
    list(id: $id) {
      id
      name
      description
      status
      isSystem
      itemType
      createdAt
      updatedAt
      items(filters: $itemFilters, sort: $itemSort) {
        totalCount
        edges {
          node {
            id
            value {
              ... on Address {
                address
                label
                entity {
                  ...EntityDisplay
                }
                risks {
                  ...AddressRiskIndicator
                }
              }
            }
            createdAt
          }
        }
      }
    }
  }
  ${EntityDisplayFragmentDoc}
  ${AddressRiskIndicatorFragmentDoc}
`;

/**
 * __useGetListQuery__
 *
 * To run a query within a React component, call `useGetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      itemFilters: // value for 'itemFilters'
 *      itemSort: // value for 'itemSort'
 *   },
 * });
 */
export function useGetListQuery(
  baseOptions: Apollo.QueryHookOptions<GetListQuery, GetListQueryVariables> &
    ({ variables: GetListQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetListQuery, GetListQueryVariables>(
    GetListDocument,
    options,
  );
}
export function useGetListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListQuery,
    GetListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetListQuery, GetListQueryVariables>(
    GetListDocument,
    options,
  );
}
export function useGetListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetListQuery, GetListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetListQuery, GetListQueryVariables>(
    GetListDocument,
    options,
  );
}
export type GetListQueryHookResult = ReturnType<typeof useGetListQuery>;
export type GetListLazyQueryHookResult = ReturnType<typeof useGetListLazyQuery>;
export type GetListSuspenseQueryHookResult = ReturnType<
  typeof useGetListSuspenseQuery
>;
export type GetListQueryResult = Apollo.QueryResult<
  GetListQuery,
  GetListQueryVariables
>;
